import React from 'react';
import { Link } from 'react-router-dom';
import MissionImg from '../../assets/img/AboutUs/vision_mission.jpg';

const Mission: React.FC = () => {
  return (
    <div className="mission-page">
      <div className="breadcrumbs">
        <div className="shell breadcrumbs-inner">
          <h1>Vision & Mission</h1>
          <ul className="breadcrumb-list">
            <li><Link to="/">Home</Link></li>
            <li><Link to="/about">About Us</Link></li>
            <li className="active">Vision & Mission</li>
          </ul>
        </div>
      </div>

      <div className="shell">
        <div className="hero-grid" style={{ padding: '40px 0' }}>
          <div className="hero-copy">
            <h2 className="section-title">Our <span className="text-gradient">Mission</span></h2>
            <p className="lead" style={{ color: 'var(--accent)', fontWeight: '600' }}>
              To enable people and companies to increase their business value through the use of IT technologies.
            </p>
            <p style={{ marginBottom: '30px' }}>
              We aim at delivering services which will open new possibilities for our customers and allow 
              them to work effectively and creatively.
            </p>

            <h3 style={{ color: 'var(--accent)', marginBottom: '15px' }}>Core Values</h3>
            
            <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
              <div className="glass-card" style={{ padding: '20px' }}>
                <h4 style={{ marginBottom: '10px' }}>People</h4>
                <p style={{ fontSize: '14px', color: 'var(--text-secondary)' }}>
                  We believe that the most valuable resource we possess is our people. OneSoft is a team 
                  of motivated, loyal and highly skilled IT professionals built on collaboration and teamwork.
                </p>
              </div>

              <div className="glass-card" style={{ padding: '20px' }}>
                <h4 style={{ marginBottom: '10px' }}>Customers</h4>
                <p style={{ fontSize: '14px', color: 'var(--text-secondary)' }}>
                  OneSoft is dedicated to its customers and partners. We believe that the most important 
                  factor of our success is the success of our clients.
                </p>
              </div>

              <div className="glass-card" style={{ padding: '20px' }}>
                <h4 style={{ marginBottom: '10px' }}>Quality</h4>
                <p style={{ fontSize: '14px', color: 'var(--text-secondary)' }}>
                  We pay special attention to quality assurance. By investing in QA, we invest in our 
                  customers' business stability and value.
                </p>
              </div>
            </div>

            <h3 style={{ color: 'var(--accent)', marginTop: '30px', marginBottom: '15px' }}>Operating Principles</h3>
            <ul className="unstyled-list">
              <li style={{ marginBottom: '10px' }}><strong>Cultural Collaboration:</strong> Bridging gaps between different cultures.</li>
              <li style={{ marginBottom: '10px' }}><strong>Smart Communication:</strong> Global availability around the clock.</li>
              <li style={{ marginBottom: '10px' }}><strong>Professionalism:</strong> Making complicated things simple and useful.</li>
            </ul>
          </div>
          <div className="hero-visual">
             <div className="glass-card" style={{ padding: '0' }}>
                <img src={MissionImg} alt="Vision Mission" style={{ width: '100%', borderRadius: '20px' }} />
             </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Mission;
